import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[cslSelectInputsByClick]',
})
export class SelectInputsByClickDirective {
  private el: ElementRef;

  constructor(private _el: ElementRef) {
    this.el = this._el;
  }

  @HostListener('click', ['$event']) onClick(e: any): void {
    if (!e.target || !((e.target.nodeName as string).toUpperCase() === 'INPUT')) {
      return;
    }

    (e.target as HTMLInputElement).select();
  }
}
